import { create } from "zustand";
import type { JournalVersion } from "./types";

const MOCK_TITLE_VERSIONS: JournalVersion[] = [
  {
    versionId: "tv5",
    versionNumber: 5,
    status: "ACTUAL",
    integrationStatus: "SENT",
    versionDate: "2025-06-07T16:41:00Z",
    responsible: { name: "Гендальф Ф. А.", role: "Офисный клерк" },
  },
  {
    versionId: "tv4",
    versionNumber: 4,
    status: "OUTDATED",
    integrationStatus: "ACCEPTED",
    versionDate: "2025-05-12T09:00:00Z",
    responsible: { name: "Гендальф Ф. А.", role: "Офисный клерк" },
  },
  {
    versionId: "tv3",
    versionNumber: 3,
    status: "OUTDATED",
    integrationStatus: "REJECTED",
    versionDate: "2025-04-01T12:30:00Z",
    responsible: { name: "Гендальф Ф. А.", role: "Офисный клерк" },
  },
  {
    versionId: "tv2",
    versionNumber: 2,
    status: "OUTDATED",
    integrationStatus: null,
    versionDate: "2025-03-10T11:00:00Z",
    responsible: { name: "Гендальф Ф. А.", role: "Офисный клерк" },
  },
  {
    versionId: "tv1",
    versionNumber: 1,
    status: "OUTDATED",
    integrationStatus: null,
    versionDate: "2025-02-01T08:00:00Z",
    responsible: { name: "Гендальф Ф. А.", role: "Офисный клерк" },
  },
];

type TitleVersionsState = {
  versions: JournalVersion[];
  setVersions: (versions: JournalVersion[]) => void;
  addVersion: (version: JournalVersion) => void;
  reset: () => void;
};

export const useTitleVersionsStore = create<TitleVersionsState>((set) => ({
  versions: MOCK_TITLE_VERSIONS,
  setVersions: (versions) => set({ versions }),
  addVersion: (version) =>
    set((state) => ({ versions: [...state.versions, version] })),
  reset: () => set({ versions: MOCK_TITLE_VERSIONS }),
}));
